export default __webpack_public_path__ + "static/media/daraa.67bda0f2.jpg";